$(document).on('turbolinks:load', () => {
  $('.apps_info__slider .slider').each(function () {
    const $slider = $(this)

    $slider.on('ready.flickity', function () {
      const $prevButton = $slider
        .find('.flickity-prev-next-button.previous')
        .detach()
      const $nextButton = $slider
        .find('.flickity-prev-next-button.next')
        .detach()
      const $pageDots = $slider.find('.flickity-page-dots').detach()

      if ($prevButton.length && $nextButton.length && $pageDots.length) {
        if ($slider.children('.flickity-controls').length === 0) {
          const $controlsWrapper = $('<div class="flickity-controls"></div>')
          $controlsWrapper.append($prevButton, $pageDots, $nextButton)
          $slider.append($controlsWrapper)
        }
      }
    })
  })

  $(document).ready(function () {
    $('[class^="apps_info__description-buttons"]').each(function () {
      const buttons = $(this).find('a')
      const totalButtons = buttons.length
      let wideIndexes = []

      buttons.each(function (index) {
        if ($(this).text().length > 20) {
          wideIndexes.push(index)
        }
      })

      wideIndexes.forEach((index) => {
        $(buttons[index]).addClass('apps_info_button_item-wide')

        if (index % 2 === 0) {
          if (index + 1 < totalButtons) {
            $(buttons[index + 1]).addClass('apps_info_button_item-wide')
          }
        } else {
          $(buttons[index - 1]).addClass('apps_info_button_item-wide')
        }
      })

      if (totalButtons % 2 !== 0) {
        buttons.last().addClass('apps_info_button_item-wide')
      }
    })
  })
})
